import { render, staticRenderFns } from "./input-recipients-numbers.vue?vue&type=template&id=1dbc1aa6&"
import script from "./input-recipients-numbers.vue?vue&type=script&lang=js&"
export * from "./input-recipients-numbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports